import React from 'react'
import { Form, Input, Select } from 'antd'
import styled from 'styled-components'
import { t } from '@/i18n'
import { taskValidators } from '../../utils/validators'

const TaskBasicInfo: React.FC<{ dataOptions?: any }> = ({ dataOptions }) => (
  <Wrapper>
    <div className="section-title">
      {t('任务基本信息')}
      <div className="section-bar" />
    </div>
    <div className="form-content">
      <Form.Item label={t('任务名称')} name="name" rules={taskValidators.name} required>
        <Input placeholder={t('请输入')} className="form-item" />
      </Form.Item>

      <Form.Item label={<span className="form-item-label">{t('任务分组')}</span>} name="groupId">
        <Select placeholder={t('请选择')} options={dataOptions?.taskGroup} className="form-item" />
      </Form.Item>
    </div>
  </Wrapper>
)

export default TaskBasicInfo

const Wrapper = styled.div`
  margin-bottom: 24px;

  .section-title {
    font-weight: 500;
    color: #1d2129;
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 88px;
      height: 6px;
      background: linear-gradient(90deg, #2090a8 0%, #4238c9 100%);
      border-radius: 0px 86px 0px 100px;
      margin-top: 8px;
    }

    .section-bar {
      content: '';
      display: block;
      width: 100%;
      height: 4px;
      background: #ebeaf9;
      margin-top: 4px;
      margin-bottom: 20px;
    }
  }

  .form-content {
    padding-left: 34px;

    .form-item-label {
      margin-left: 12px;
    }

    .form-item {
      width: 360px;
    }
  }
`
